import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import styles from './Carousel.module.css';
import 'react-multi-carousel/lib/styles.css';
import BuzzImage from '../BuzzImage/BuzzImage';
import Carousel from 'react-multi-carousel';

function CarouselImage({ data }) {
  const [imgData, setImgData] = useState([]);
  useEffect(() => {
    setImgData(data);
  }, [data]);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1500 },
      items: 1,
      partialVisibilityGutter: 140,
    },
    tablet: {
      breakpoint: { max: 1500, min: 1024 },
      items: 1,
      partialVisibilityGutter: 90,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 50,
    },
  };

  return (
    <Box className={styles.carouselConatiner}>
      <p className={styles.text}>Our managements</p>
      <Box className={styles.carouselBorder}>
        <Carousel
          partialVisible
          autoPlay={true}
          autoPlaySpeed={3000}
          responsive={responsive}>
          {imgData.map((item, i) => {
            return (
              <Box className={styles.carouselBox} key={i}>
                <Item data={item} />
              </Box>
            );
          })}
        </Carousel>
      </Box>
    </Box>
  );
}

export default CarouselImage;

function Item(props) {
  const { name, salutation, role, imageFullUrl } = props.data;
  return (
    <Box className={styles.itemContainer}>
      <Box className={styles.itemDetails}>
        <BuzzImage
          src={imageFullUrl}
          alt="managementImage"
          className={styles.imgs}
        />
        <p className={styles.names}>
          {salutation} {name}
        </p>
        <p className={styles.role}>Role - {role}</p>
      </Box>
    </Box>
  );
}
